import React from 'react';
import styles from './messageBox.module.css'

const MoreOption =()=>{
  return(  <div className={styles.MoreOptionCon}>
            <div>
                Setting
            </div>
            <div>
                Setting
            </div>
            <div>
                Setting
            </div>
        

    </div>)
}

export default MoreOption